import type { PictureView } from 'app/typings/core/common/pictureView/pictureView';
import { assertNever } from 'app/utils/typing';

import { SingleImage } from '../../../../commons/Images/SingleImage/SingleImage';
import { TripleImages } from '../../../../commons/Images/TripleImages/TripleImages';
import { InventoryTabItemName } from '../../ExtranetInventory/Modern/InventoryStore';
import { PackType } from '../../ExtranetInventory/Modern/_components/Header/ActionsBar/InventoryToggle/InventoryToggle';
import { useInventoryState } from '../../ExtranetInventory/Modern/hooks';

export const RetrieveImage = ({
  images,
}: {
  images?: [PictureView, PictureView, PictureView];
}) => {
  const { tab, packType } = useInventoryState();

  if (packType === PackType.DAYTIME) {
    return (
      <SingleImage
        image={
          images?.[0] || {
            path: 'path1',
            alt: 'alt1',
            id: 1,
            createdAt: new Date(),
            updatedAt: new Date(),
            dimensions: { width: 100, height: 100 },
          }
        }
      />
    );
  }

  switch (tab.name) {
    case InventoryTabItemName.Packs:
      return (
        <TripleImages
          images={
            images || [
              {
                path: 'path1',
                alt: 'alt1',
                id: 1,
                createdAt: new Date(),
                updatedAt: new Date(),
                dimensions: { width: 100, height: 100 },
              },
              {
                path: 'path2',
                alt: 'alt2',
                id: 2,
                createdAt: new Date(),
                updatedAt: new Date(),
                dimensions: { width: 100, height: 100 },
              },
              {
                path: 'path3',
                alt: 'alt3',
                id: 3,
                createdAt: new Date(),
                updatedAt: new Date(),
                dimensions: { width: 100, height: 100 },
              },
            ]
          }
        />
      );

    case InventoryTabItemName.Rooms:
    case InventoryTabItemName.Experiences:
      return (
        <SingleImage
          image={
            images?.[0] || {
              path: 'path1',
              alt: 'alt1',
              id: 1,
              createdAt: new Date(),
              updatedAt: new Date(),
              dimensions: { width: 100, height: 100 },
            }
          }
        />
      );

    default:
      return assertNever(tab.name);
  }
};
